export interface Environment {
  production: boolean;
  environmentName: 'SND' | 'DEV' | 'PRE' | 'PRO';
  apiUrl: string;
  googleMapsApiKey: string;
  activityRegistryApiUrl: string,
  activityRegistryApiKey: string,
}
